<ng-container *ngIf="groupedBanners$ | async as groupedBanners">
  <div *ngIf="groupedBanners.length">
    <sd-swiper [items]="groupedBanners" [config]="defaultConfig">
      <ng-template #slide let-items="item" let-classList="classList">
        <div class="item-wrapper {{ classList }}">
          <div class="row">
            <ng-container
              *ngFor="let item of items"
              [cxComponentWrapper]="{
                flexType: item.typeCode,
                typeCode: item.typeCode,
                uid: item?.uid,
              }"
            ></ng-container>
          </div>
        </div>
      </ng-template>
    </sd-swiper>
  </div>
</ng-container>
